import { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import type { MediaPlan } from '@mint-sdk/api-media-plan';

import AddRowButton from './AddRowButton.jsx';
import DuplicateRowButton from './DuplicateRowButton.jsx';

const PinnedRightButton = (
  props: CustomCellRendererProps<MediaPlan.MediaData>,
) => {
  if (props.node.rowPinned) {
    return null;
  }

  if (props.data?.levelType === 'media_row') {
    return <DuplicateRowButton {...props} />;
  }

  return <AddRowButton {...props} />;
};

export default PinnedRightButton;
